import { useCallback, useMemo } from 'react';
import { Link, mergeClasses } from '@fluentui/react-components';
import { useNavigate } from 'react-router-dom';
import { IRouteLinkProps } from './RouteLink.types';
import { useRouteLinkStyles } from './RouteLink.styles';

const RouteLink = (props: IRouteLinkProps) => {
    const { id, text, url, href, inverted, className, appearance, onClick, target } = props;

    const styles = useRouteLinkStyles();
    const navigate = useNavigate();

    const classes = useMemo(
        () => mergeClasses(inverted && styles.inverted, className),
        [inverted, className]
    );

    const handleNavigate = useCallback(() => {
        if (target === '_blank') {
            window.open(url);
        } else {
            navigate(url ? url : '/');
            scrollTo(0, 0);
        }

        if (onClick) onClick();
    }, [url]);

    return (
        <Link
            id={id}
            data-testid={`${id}-test`}
            className={classes}
            onClick={url ? handleNavigate : onClick}
            href={href}
            appearance={appearance === 'default' ? 'default' : 'subtle'}
        >
            {text}
        </Link>
    );
};

export default RouteLink;
